<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'informes' }">{{ $t("informes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("gastosPorProveedor") }}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambiarNegocio()" :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName"
                                        :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("proveedores") }}</strong></label>

                                <el-select class="select-default" size="large" v-model="idSupplier" filterable
                                    :placeholder="$t('seleccionaProveedor')" @change="getGastosNegocio()">
                                    <el-option v-for="su in listProveedores" class="select-primary" :value="su.id"
                                        :label="su.name" :key="su.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="listProcedencia">{{ $t("procedencia") }}</label>

                                <el-select class="select-default" size="large" v-model="procedencia" filterable
                                    @change="consultar()" :placeholder="$t('seleccionaProcedencia')">
                                    <el-option class="select-primary" :value=2 :label="$t('todos')" :key=2>
                                    </el-option>
                                    <el-option class="select-primary" :value=1 :label="$t('deCaja')" :key=1>
                                    </el-option>
                                    <el-option class="select-primary" :value=0 :label="$t('fueraDeCaja')" :key=0>
                                    </el-option>

                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{ $t("fechaInicio") }}</label>
                                <datetime value-zone="Europe/Madrid" :auto="true" class="theme-numier"
                                    format="dd-MM-yyyy" :title="$t('fechaInicio')"
                                    :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control"
                                    v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{ $t("fechaFin") }}</label>
                                <datetime value-zone="Europe/Madrid" :auto="true" class="theme-numier"
                                    :title="$t('fechaFin')" format="dd-MM-yyyy"
                                    :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control"
                                    v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="consultar()"><i class="fa fa-refresh"
                                        v-if="loading"></i>
                                    {{ $t("consultar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">

                <div class="col-md-12">
                    <div class="card">
                        <template v-if="list.length > 0">



                            <div class="row col-md-6" style="margin-bottom: 10px">
                                <div v-show="nameSelectedProv != ''" class="col-md-3 col-xs-12">
                                    <button @click="volver()" class="btn btn-primary btn-sm"><i
                                            class="fas fa-arrow-circle-left"></i>
                                        {{ $t("volverAGeneral") }}
                                    </button>
                                </div>
                                <div class="col-md-2 col-xs-12">
                                    <el-dropdown>
                                        <el-button type="primary" size="small">
                                            <i class="fa fa-file"></i>
                                            {{ $t("exportarInforme") }} <i
                                                class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <a v-if="nameSelectedProv == ''" :href="urlExportSuppliersPDF">
                                                <el-dropdown-item class="text-danger">
                                                    <strong><i class="fa fa-file-pdf"></i>
                                                        {{ $t("exportarPdf") }}</strong>
                                                </el-dropdown-item>
                                            </a>
                                            <a v-else :href="urlExportGastosBySupplierPDF">
                                                <el-dropdown-item class="text-danger">
                                                    <strong><i class="fa fa-file-pdf"></i>
                                                        {{ $t("exportarPdf") }}</strong>
                                                </el-dropdown-item>
                                            </a>
                                            <a v-if="nameSelectedProv == ''" :href="urlExportSuppliersExcel">
                                                <el-dropdown-item class="text-success">
                                                    <strong><i class="fa fa-file-excel"></i>
                                                        {{ $t("exportarExcel") }}</strong>
                                                </el-dropdown-item>
                                            </a>
                                            <a v-else :href="urlExportGastosBySupplierExcel">
                                                <el-dropdown-item class="text-success">
                                                    <strong><i class="fa fa-file-excel"></i>
                                                        {{ $t("exportarExcel") }}</strong>
                                                </el-dropdown-item>
                                            </a>
                                            <!--urlExportGastosBySupplierExcel-->
                                        </el-dropdown-menu>
                                    </el-dropdown>



                                </div>
                            </div>

                            <!--TABLA DE PROVEEDORES-->
                            <div class="table-responsive" v-show="nameSelectedProv == ''">
                                <table class="table table-bordered table-striped">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>
                                                <span v-if="ordenarConcepto"
                                                    @click="sortedArrayASC(1), ordenarConcepto = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{
                                                                $t("concepto")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(1), ordenarConcepto = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("concepto") }}
                                                </span>

                                            </th>
                                            <th>
                                                <span v-if="ordenarCategoria"
                                                    @click="sortedArrayASC(2), ordenarCategoria = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("categoria") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(2), ordenarCategoria = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("categoria") }}
                                                </span>

                                            </th>
                                            <th>
                                                <span v-if="ordenarImporte"
                                                    @click="sortedArrayASC(3), ordenarImporte = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{
                                                                $t("importe")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(3), ordenarImporte = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("importe") }}
                                                </span>

                                            </th>
                                            <th>{{ $t('acciones') }}</th>
                                        </tr>
                                    </thead>
                                    <!--PONER LA MISMA TABLA DE GASTOS-->
                                    <tbody>
                                        <tr v-for="(obj, index) in list">
                                            <td>{{ obj.supplierName }}</td>
                                            <td>{{ obj.nameTag }}</td>
                                            <td class="text-right">{{ obj.price | currency }}</td>
                                            <td align="center">

                                                <div class="flex-row">
                                                    <div v-if="obj.ref.length > 0" @click="showFacturas(index, obj)">

                                                        <!-- TODO: Agregar tooltip v-tooltip.top-center="$t('desgloseDeFacturasPorProveedor')"-->
                                                        <i class="fas fa-arrow-circle-right" style="cursor: pointer"
                                                            v-tooltip.top-center="$t('verDesgloseFacturas')"></i>

                                                    </div>
                                                    <div v-if="obj.ref.length > 0"
                                                        @click="openModal(index, obj.supplierName)"
                                                        class="btn btn-link">
                                                        <i class="fas fa-list-ul text-primary" style="cursor: pointer"
                                                            v-tooltip.top-center="$t('verDesgloseMateriasPrimas')"></i>
                                                    </div>
                                                </div>


                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="table-success">
                                            <td><strong>{{ $t("total") }}</strong></td>
                                            <td></td>
                                            <td class="text-right"><strong>{{ getTotalPrecio | currency }}</strong></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <!-- v-show="nameSelectedProv != ''"-->
                            <!--TABLA FACTURAS PARA DESGLOSE DE PRODUCTOS-->
                            <div class="table-responsive" v-show="nameSelectedProv != ''" v-if="list.length > 0">
                                <div class="col-md-12">
                                    <h4 style="margin: 0px 0px 10px 0px">{{ $t("facturasDelProveedor") }} : <span
                                            class="text-primary">{{ nameSelectedProv }}</span>
                                    </h4>
                                </div>


                                <table class="table table-bordered table-striped">
                                    <thead class="thead-dark">
                                        <tr>

                                            <th>
                                                <span v-if="ordenarFecha"
                                                    @click="sortedArrayASC(8), (ordenarFecha = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("fecha") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(8), (ordenarFecha = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("fecha") }}
                                                </span>
                                            </th>
                                            <th>

                                                <span v-if="ordenarBase"
                                                    @click="sortedArrayASC(9), (ordenarBase = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("base") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(9), (ordenarBase = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("base") }}
                                                </span>
                                            </th>
                                            <th>

                                                <span v-if="ordenarImporteIVA"
                                                    @click="sortedArrayASC(10), (ordenarImporteIVA = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("importeIVA") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(10), (ordenarImporteIVA = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("importeIVA") }}
                                                </span>
                                            </th>
                                            <th>


                                                <span v-if="ordenarImporte"
                                                    @click="sortedArrayASC(11), (ordenarImporte = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("importe") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(11), (ordenarImporte = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("importe") }}
                                                </span>
                                            </th>
                                            <th>


                                                <span v-if="ordenarReferencia"
                                                    @click="sortedArrayASC(12), (ordenarReferencia = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("referencia") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(12), (ordenarReferencia = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("referencia") }}
                                                </span>
                                            </th>
                                            <th>

                                                <span v-if="ordenarTipo"
                                                    @click="sortedArrayASC(13), (ordenarTipo = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("tipo") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(13), (ordenarTipo = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("tipo") }}
                                                </span>
                                            </th>
                                            <th>


                                                <span v-if="ordenarProcedencia"
                                                    @click="sortedArrayASC(14), (ordenarProcedencia = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("procedencia") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(14), (ordenarProcedencia = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("procedencia") }}
                                                </span>
                                            </th>
                                            <th>

                                                <span v-if="ordenarFormaDePago"
                                                    @click="sortedArrayASC(15), (ordenarFormaDePago = 0)"><i
                                                        style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("formaDePago") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(15), (ordenarFormaDePago = 1)"><i
                                                        style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("formaDePago") }}
                                                </span>
                                            </th>

                                            <th>{{ $t("acciones") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(obj, index) in listSelectedFacturas">


                                            <td style="width: 10%">
                                                <span v-if="obj.fromCash !== 1">{{
                                                        obj.date | parseDate
                                                }}</span><span v-else>{{ obj.date | parseDateMin }}</span>
                                            </td>
                                            <!-- <td>{{ obj.supplierName }}</td> -->
                                            <td align="right" style="width: 10%">
                                                {{ obj.base | currency }}
                                            </td>
                                            <td align="right" style="width: 10%">
                                                {{ obj.importeIVA | currency }}
                                            </td>
                                            <td align="right" style="width: 10%">
                                                {{ obj.price | currency }}
                                            </td>
                                            <td>{{ obj.ref }}</td>
                                            <td>
                                                <span v-if="obj.type === 'F'">{{ $t("factura") }}</span>
                                                <span v-else>{{ $t("albaran") }}</span>
                                            </td>
                                            <td>
                                                <span v-if="obj.fromCash === 1">{{ $t("deCaja") }}</span>
                                                <span v-else>{{ $t("fueraDeCaja") }} </span>
                                            </td>
                                            <td>
                                                <span v-if="obj.formaPago === 0">{{
                                                        $t("tranferencia")
                                                }}</span>
                                                <span v-else-if="obj.formaPago === 1">{{
                                                        $t("domiciliacion")
                                                }}</span>
                                                <span v-else>{{ $t("efectivo") }}</span>
                                            </td>

                                            <td>
                                                <!-- v-if=" this.listSelectedFacturas[index].listaSubproductos > 0"-->
                                                <template class="btn btn-link" v-if="obj.listaSubproductos.length > 0">
                                                    <i class="fas fa-list-ul text-primary"
                                                        @click="openSubproductModal(index)" style="cursor: pointer"
                                                        v-tooltip.top-center="$t('verDesgloseFacturas')"></i>
                                                </template>
                                            </td>

                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="table-success">
                                            <td>
                                                <strong>{{ $t("total") }}</strong>
                                            </td>

                                            <td class="text-right">
                                                <!-- <strong>{{ getTotalBase | currency }}</strong> -->
                                            </td>
                                            <td></td>
                                            <td class="text-right">
                                                <strong>{{ getTotalFacturas | currency }}</strong>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>

                            </div>
                        </template>
                        <template v-else>
                            <p><i class="fa fa-info-circle"></i>
                                <small>
                                    {{ $t("infoConsumo") }}
                                </small>
                            </p>
                            <div class="alert alert-danger" role="alert">
                                {{ $t("noHay") }} <strong>{{ $t("gastos") }}</strong> {{ $t("rangoDeFechas") }}
                            </div>
                        </template>
                    </div>
                </div>
                <modal name="modal-product" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
                    <div>
                        <div class="modal-header">

                            <h4 style="margin: 0px">Referencias <span class="text-primary">{{ primaSelectedName }}
                                </span></h4>

                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th><span v-if="ordenarModNombre"
                                                    @click="sortedArrayASC(16), ordenarModNombre = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("nombre")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(16), ordenarModNombre = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("nombre")
                                                        }}
                                                </span>
                                            </th>
                                            <th><span v-if="ordenarModDescripcion"
                                                    @click="sortedArrayASC(17), ordenarModDescripcion = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{
                                                                $t("descripcion")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(17), ordenarModDescripcion = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("descripcion")
                                                        }}
                                                </span>
                                            </th>
                                            <th><span v-if="ordenarModUd"
                                                    @click="sortedArrayASC(18), ordenarModUd = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("ud.") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(18), ordenarModUd = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{ $t("ud.")
                                                        }}
                                                </span>
                                            </th>
                                            <th> <span v-if="ordenarModPartes"
                                                    @click="sortedArrayASC(19), ordenarModPartes = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("partes")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(19), ordenarModPartes = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("partes")
                                                        }}
                                                </span>
                                            </th>
                                            <th> <span v-if="ordenarModPrice"
                                                    @click="sortedArrayASC(20), ordenarModPrice = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("precio")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(20), ordenarModPrice = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("precio")
                                                        }}
                                                </span>
                                            </th>

                                            <th> <span v-if="ordenarModImporte"
                                                    @click="sortedArrayASC(20), ordenarModImporte = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("total")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(20), ordenarModImporte = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("total")
                                                        }}
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="mp in listSubproducts">
                                            <td>{{ mp.nameSubproduct }}</td>
                                            <td>{{ mp.description }}</td>
                                            <td>{{ mp.unidades }} {{ mp.type }}</td>
                                            <td>{{ mp.partes }}</td>
                                            <td>{{ mp.precioIVA | currency }}</td>
                                            <td>{{ mp.total | currency }}</td>


                                        </tr>

                                    </tbody>
                                    <tfoot>
                                        <tr class="table-success">
                                            <td><strong>{{ $t("total") }}</strong></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td><strong>{{ getTotalSubproducts | currency }}</strong></td>

                                        </tr>
                                    </tfoot>
                                </table>
                            </div>


                        </div>
                        <div class="modal-footer">
                            <div align="right" class="col-12">
                                <button @click="$modal.hide('modal-product')" class="btn btn-danger"><i
                                        class="fas fa-arrow-circle-left"></i>
                                    {{ $t("volver") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="modal-ver-ref" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
                    <div>
                        <div class="modal-header">

                            <h4 style="margin: 0px">{{ $t('referencias') }} <span class="text-primary">{{ nameProveedor
                            }}
                                </span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>
                                                <span v-if="ordenarModNombre"
                                                    @click="sortedArrayASC(4), ordenarModNombre = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("nombre")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(4), ordenarModNombre = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("nombre")
                                                        }}
                                                </span>
                                            </th>
                                            <th>
                                                <span v-if="ordenarModUd"
                                                    @click="sortedArrayASC(5), ordenarModUd = 0"><i style="color: white"
                                                        class="fa fa-angle-up"></i> {{ $t("ud") }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(5), ordenarModUd = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{ $t("ud")
                                                        }}
                                                </span>
                                            </th>
                                            <th>
                                                <span v-if="ordenarModPartes"
                                                    @click="sortedArrayASC(6), ordenarModPartes = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("partes")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(6), ordenarModPartes = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("partes")
                                                        }}
                                                </span>
                                            </th>
                                            <th>
                                                <span v-if="ordenarModImporte"
                                                    @click="sortedArrayASC(7), ordenarModImporte = 0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{ $t("total")
                                                        }}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(7), ordenarModImporte = 1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{
                                                                $t("total")
                                                        }}
                                                </span>
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fac in listPrimasProveedor">
                                            <td>{{ fac.name }}</td>
                                            <td>{{ fac.ud }}</td>
                                            <td>{{ fac.partes }}</td>
                                            <td>{{ fac.total | currency }}</td>

                                        </tr>

                                    </tbody>
                                    <tfoot>
                                        <tr class="table-success">
                                            <td><strong>{{ $t("total") }}</strong></td>
                                            <td></td>
                                            <td></td>

                                            <td><strong>{{ getTotalFacturasPrimas | currency }}</strong></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>


                        </div>
                        <div class="modal-footer">
                            <div align="right" class="col-12">
                                <button @click="$modal.hide('modal-ver-ref')" class="btn btn-danger"><i
                                        class="fas fa-arrow-circle-left"></i>
                                    {{ $t("volver") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </modal>
            </template>
        </div>

    </div>

</template>

<script>

//import Datepicker from 'vuejs-datepicker';
//import Chart from 'chart.js';
import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button } from 'element-ui'
import swal from 'sweetalert2'
import moment from 'moment'
import { Loading } from "element-ui";
import { mapState } from 'vuex';

export default {
    created() {

        this.loadingGeneral = Loading.service({ text: this.$t("cargandoGastos") });
        this.$store.dispatch("setNameRoute", this.$i18n.t("gastosPorProveedor"));
        this.getBusiness();

        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;

        }
    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option
    },
    data() {
        return {

            loadingGeneral: null,
            loading: false,
            datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
            dateto: new Date().toISOString(),
            listBusinesses: [],
            idBusiness: 0,
            value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
            list: [],
            mode: 0,
            procedencia: 2,
            $Chart: null,
            objectChart: null,
            contador: 0,

            idSupplier: 0,
            listProveedores: [],

            listPrimasProveedor: [],
            nameProveedor: [],
            //Arrays para cargar al iniciar la pagina
            listEveryFactura: [],


            //ORDENAR
            ordenarConcepto: 0,
            ordenarCategoria: 0,
            ordenarImporte: 0,

            listGastos: [],

            listSubproducts: [],
            primaSelectedName: '',

            //DESGLOSE PRODUCTOS
            //Seleccionado al entrar en el desglose
            selectedProvId: 0,
            nameSelectedProv: '',

            listSelectedFacturas: [],

            nameMateriaFactura: '',

            //ORDENAR MODAL
            ordenarModNombre: 0,
            ordenarModUd: 0,
            ordenarModPartes: 0,
            ordenarModImporte: 0,
            ordenarModDescripcion: 0,
            ordenarModTipo: 0,
            ordenarModPrice: 0,


            //ORDENAR TABLA FACTURAS
            ordenarFecha: 0,
            ordenarProveedor: 0,
            ordenarBase: 0,
            ordenarImporteIVA: 0,
            ordenarImporte: 0,
            ordenarReferencia: 0,
            ordenarTipo: 0,
            ordenarProcedencia: 0,
            ordenarFormaDePago: 0,



            respuesta: true,
        }
    },

    computed: {
        ...mapState(["permiso"]),
        urlExportSuppliersPDF() {

            return (
                this.$store.getters.apiUrl +
                "/suppliers/exportGastosSupplier/PDF?idBusiness=" +
                this.idBusiness +
                "&procedencia=" +
                this.procedencia +
                "&mode=" +
                this.mode +
                "&idSupplier=" +
                this.idSupplier +
                "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );


        },


        urlExportSuppliersExcel() {

            return this.$store.getters.apiUrl +
                "/suppliers/exportGastosSupplier/Excel?idBusiness=" +
                this.idBusiness +
                "&procedencia=" +
                this.procedencia +
                "&mode=" +
                1 +
                "&idSupplier=" +
                this.idSupplier +
                "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt

        },
        urlExportGastosBySupplierPDF() {
            //exportGastosBySupplier
            return (
                this.$store.getters.apiUrl +
                "/gastos/exportGastosFromSupplier/PDF?idBusiness=" +
                this.idBusiness +
                "&procedencia=" +
                this.procedencia +
                "&mode=" +
                1 +
                "&idSupplier=" +
                this.idSupplier +
                "&filtrarPorFecha=" +
                true +
                "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },
        urlExportGastosBySupplierExcel() {
            return (
                this.$store.getters.apiUrl +
                "/gastos/exportGastosFromSupplier/Excel?idBusiness=" +
                this.idBusiness +
                "&procedencia=" +
                this.procedencia +
                "&mode=" +
                1 +
                "&idSupplier=" +
                this.idSupplier +
                "&filtrarPorFecha=" +
                true +
                "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },

        getTotalPrecio() {
            let total = 0;
            this.list.forEach(function (d) {

                total += d.price;

            });
            return total;
        },
        //Total de los importes del deglose por materias primas
        getTotalFacturasPrimas() {

            let xTotal = 0;

            this.listPrimasProveedor.forEach(function (x) {


                xTotal += x.total;

            });


            return xTotal;
        },

        //Total de los importes del desglose por facturas
        getTotalFacturas() {

            let xTotal = 0;

            this.listSelectedFacturas.forEach(function (x) {


                xTotal += x.price;

            });


            return xTotal;
        },

        getTotalSubproducts() {

            let xTotal = 0;

            this.listSubproducts.forEach(function (x) {

                xTotal += parseFloat(x.total);

            });

            return xTotal;
        },



    },
    methods: {




        sortedArrayASC: function (nameAtributo) {


            switch (nameAtributo) {

                case 1:

                    this.ordenarConcepto = 1;

                    function compareConcepto(a, b) {

                        if (a.supplierName.toUpperCase() < b.supplierName.toUpperCase())
                            return -1;
                        if (a.supplierName.toUpperCase() > b.supplierName.toUpperCase())
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareConcepto);

                case 2:

                    this.ordenarCategoria = 1;

                    function compareCategoria(a, b) {

                        if (a.nameTag < b.nameTag)
                            return -1;
                        if (a.nameTag > b.nameTag)
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareCategoria);

                case 3:

                    this.ordenarImporte = 1;

                    function compareImporte(a, b) {

                        if (a.price < b.price)
                            return -1;
                        if (a.price > b.price)
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareImporte);

                case 4:

                    this.ordenarModNombre = 1;

                    function compare(a, b) {

                        if (a.name.toUpperCase() < b.name.toUpperCase())
                            return -1;
                        if (a.name.toUpperCase() > b.name.toUpperCase())
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compare);

                case 5:

                    this.ordenarModUd = 1;

                    function compare(a, b) {

                        if (a.ud < b.ud)
                            return -1;
                        if (a.ud > b.ud)
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compare);

                case 6:

                    this.ordenarModPartes = 1;

                    function compare(a, b) {

                        if (a.partes < b.partes)
                            return -1;
                        if (a.partes > b.partes)
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compare);

                case 7:

                    this.ordenarModImporte = 1;

                    function compareModImporte(a, b) {

                        if (a.total < b.total)
                            return -1;
                        if (a.total > b.total)
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compareModImporte);


                case 8:
                    this.ordenarFecha = 1;

                    function compare(a, b) {

                        if (a.date > b.date)
                            return -1;
                        if (a.date < b.date)
                            return 1;
                        return 0;

                    }
                    return this.listSelectedFacturas.sort(compare);

                case 9:

                    this.ordenarBase = 1;

                    function compare(a, b) {

                        if (a.base > b.base)
                            return -1;
                        if (a.base < b.base)
                            return 1;
                        return 0;

                    }
                    return this.listSelectedFacturas.sort(compare);

                case 10:

                    this.ordenarImporteIVA = 1;

                    function compare(a, b) {

                        if (a.importeIVA < b.importeIVA)
                            return -1;
                        if (a.importeIVA > b.importeIVA)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 11:

                    this.ordenarImporte = 1;

                    function compare(a, b) {

                        if (a.price < b.price)
                            return -1;
                        if (a.price > b.price)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 12:

                    this.ordenarReferencia = 1;

                    function compare(a, b) {

                        if (a.price < b.price)
                            return -1;
                        if (a.price > b.price)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 13:

                    this.ordenarTipo = 1;


                    function compare(a, b) {

                        if (a.type < b.type)
                            return -1;
                        if (a.type > b.type)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);


                case 14:

                    this.ordenarProcedencia = 1;


                    function compare(a, b) {

                        if (a.fromCash < b.fromCash)
                            return -1;
                        if (a.fromCash > b.fromCash)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 15:

                    this.ordenarFormaDePago = 1;

                    function compare(a, b) {

                        if (a.formaPago < b.formaPago)
                            return -1;
                        if (a.formaPago > b.formaPago)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 16:

                    this.ordenarModNombre = 1;

                    function compare(a, b) {

                        if (a.nameSubproduct < b.nameSubproduct)
                            return -1;
                        if (a.nameSubproduct > b.nameSubproduct)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 17:

                    this.ordenarModDescripcion = 1;

                    function compare(a, b) {

                        if (a.description < b.description)
                            return -1;
                        if (a.description > b.description)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 18:

                    this.ordenarModUd = 1;

                    function compare(a, b) {

                        if (a.unidades < b.unidades)
                            return -1;
                        if (a.unidades > b.unidades)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);


                case 19:

                    this.ordenarModPartes = 1;

                    function compare(a, b) {

                        if (a.partes < b.partes)
                            return -1;
                        if (a.partes > b.partes)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);


                case 20:

                    this.ordenarModPrice = 1;

                    function compare(a, b) {

                        if (a.precioIVA < b.precioIVA)
                            return -1;
                        if (a.precioIVA > b.precioIVA)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 21:

                    this.ordenarModImporte = 1;

                    function compare(a, b) {

                        if (a.total < b.total)
                            return -1;
                        if (a.total > b.total)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);


            }

        },
        sortedArrayDESC: function (nameAtributo) {


            switch (nameAtributo) {

                case 1:

                    this.ordenarConcepto = 0;

                    function compareConcepto(a, b) {

                        if (a.supplierName.toUpperCase() > b.supplierName.toUpperCase())
                            return -1;
                        if (a.supplierName.toUpperCase() < b.supplierName.toUpperCase())
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareConcepto);

                case 2:

                    this.ordenarCategoria = 0;

                    function compareCategoria(a, b) {

                        if (a.nameTag > b.nameTag)
                            return -1;
                        if (a.nameTag < b.nameTag)
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareCategoria);

                case 3:

                    this.ordenarImporte = 0;

                    function compareImporte(a, b) {

                        if (a.price > b.price)
                            return -1;
                        if (a.price < b.price)
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareImporte);

                case 4:

                    this.ordenarModNombre = 0;

                    function compare(a, b) {

                        if (a.name.toUpperCase() > b.name.toUpperCase())
                            return -1;
                        if (a.name.toUpperCase() < b.name.toUpperCase())
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compare);

                case 5:

                    this.ordenarModUd = 0;

                    function COMPARE(a, b) {

                        if (a.ud > b.ud)
                            return -1;
                        if (a.ud < b.ud)
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(COMPARE);

                case 6:

                    this.ordenarModPartes = 0;

                    function compare(a, b) {

                        if (a.partes > b.partes)
                            return -1;
                        if (a.partes < b.partes)
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compare);

                case 7:

                    this.ordenarModImporte = 0;

                    function compareModImporte(a, b) {

                        if (a.total > b.total)
                            return -1;
                        if (a.total < b.total)
                            return 1;
                        return 0;
                    }

                    return this.listPrimasProveedor.sort(compareModImporte);

                case 8:
                    this.ordenarFecha = 0;

                    function compare(a, b) {

                        if (a.date < b.date)
                            return -1;
                        if (a.date > b.date)
                            return 1;
                        return 0;

                    }
                    return this.listSelectedFacturas.sort(compare);

                case 9:

                    this.ordenarBase = 0;


                    function compare(a, b) {

                        if (a.base < b.base)
                            return -1;
                        if (a.base > b.base)
                            return 1;
                        return 0;

                    }
                    return this.listSelectedFacturas.sort(compare);

                case 10:
                    this.ordenarImporteIVA = 0;

                    function compare(a, b) {

                        if (a.importeIVA > b.importeIVA)
                            return -1;
                        if (a.importeIVA < b.importeIVA)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 11:

                    this.ordenarImporte = 0;

                    function compare(a, b) {

                        if (a.price > b.price)
                            return -1;
                        if (a.price < b.price)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);


                case 12:

                    this.ordenarReferencia = 0;

                    function compare(a, b) {

                        if (a.ref > b.ref)
                            return -1;
                        if (a.ref < b.ref)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);
                case 13:

                    this.ordenarTipo = 0;


                    function compare(a, b) {

                        if (a.type > b.type)
                            return -1;
                        if (a.type < b.type)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);


                case 14:

                    this.ordenarProcedencia = 0;


                    function compare(a, b) {

                        if (a.fromCash > b.fromCash)
                            return -1;
                        if (a.fromCash < b.fromCash)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);


                case 15:

                    this.ordenarFormaDePago = 0;

                    function compare(a, b) {

                        if (a.formaPago > b.formaPago)
                            return -1;
                        if (a.formaPago < b.formaPago)
                            return 1;
                        return 0;
                    }

                    return this.listSelectedFacturas.sort(compare);

                case 16:

                    this.ordenarModNombre = 0;

                    function compare(a, b) {

                        if (a.nameSubproduct > b.nameSubproduct)
                            return -1;
                        if (a.nameSubproduct < b.nameSubproduct)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 17:

                    this.ordenarModDescripcion = 0;

                    function compare(a, b) {

                        if (a.description > b.description)
                            return -1;
                        if (a.description < b.description)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 18:

                    this.ordenarModUd = 0;

                    function compare(a, b) {

                        if (a.type > b.type)
                            return -1;
                        if (a.type < b.type)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 19:

                    this.ordenarModPartes = 0;

                    function compare(a, b) {

                        if (a.partes > b.partes)
                            return -1;
                        if (a.partes < b.partes)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 20:

                    this.ordenarModPrice = 0;

                    function compare(a, b) {

                        if (a.precioIVA > b.precioIVA)
                            return -1;
                        if (a.precioIVA < b.precioIVA)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);

                case 21:

                    this.ordenarModImporte = 0;

                    function compare(a, b) {

                        if (a.total > b.total)
                            return -1;
                        if (a.total < b.total)
                            return 1;
                        return 0;
                    }

                    return this.listSubproducts.sort(compare);


            }

        },


        openModal(index, nameSupplier) {

            this.$modal.show("modal-ver-ref");
            this.listPrimasProveedor = this.list[index]["ref"];


            this.nameProveedor = nameSupplier;


        },

        //Modal de los subproductos desde el desglose de facturas
        openSubproductModal(index) {
            this.$modal.show("modal-product");
            this.listSubproducts = this.listSelectedFacturas[index]["listaSubproductos"];
            
        },

        //Al entrar en el desglose de las facturas y cambiar de tabla
        showFacturas(index, obj) {


            this.idSupplier = obj.supplierId;
            this.mode = 1;
            this.nameSelectedProv = obj.supplierName;

            this.listSelectedFacturas = this.listEveryFactura[index]
            this.getGastosProveedor(obj.supplierId);

        },

        consultar() {
            this.listEveryFactura = [];
            this.listSelectedFacturas = [];
            this.listEverySubproduct = [];
            this.listSubproducts = [];
            this.mode = 0;
            this.getGastosNegocio();
        },

        //Al volver de la tabla de detalles de las facturas
        volver() {
            this.loadingGeneral = Loading.service({ text: this.$t("cargandoGastos") });

            this.listEveryFactura = [];
            this.listEverySubproduct = [];
            this.listSubproducts = [];
            this.listSelectedFacturas = [];
            this.idSupplier = 0;
            this.mode = 0;
            this.nameSelectedProv = '';
            this.selectedProvId = '';
            this.listPrimasProveedor = [];

            this.getGastosNegocio()



        },



        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {
                    vm.listBusinesses = response.data.result;

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {
                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.getProveedores();
                })
                .catch(function (error) {
                    vm.loadingGeneral.close();
                    console.log(error);
                });
        },

        //Se reinician los datos al cambiar de negocio
        cambiarNegocio() {

            this.listSubproducts = [];
            this.listSelectedFacturas = [];
            this.primaSelectedName = '';
            this.selectedProvId = 0;
            this.idSupplier = 0;
            this.nameSelectedProv = '';
            this.nameMateriaFactura = '';
            this.listProveedores = [];
            this.getProveedores();
        },


        getProveedores() {

            var config = {
                params: {
                    pag: 0,
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "suppliers/getSuppliersByBusiness", config)
                .then(function (response) {



                    if (response.data.response) {
                        if (response.data.result.suppliers.length === 0) {
                            let proveedor = {
                                name: vm.$t("todos"),
                                id: 0,
                            };

                            vm.listProveedores.push(proveedor);
                        }

                        for (let i = 0; i < response.data.result.suppliers.length; i++) {
                            if (i === 0) {
                                let proveedor = {
                                    name: vm.$t("todos"),
                                    id: 0,
                                };

                                vm.listProveedores.push(proveedor);
                            }

                            let proveedorname = {
                                name: response.data.result.suppliers[i].name,
                                id: response.data.result.suppliers[i].id,
                            };

                            vm.listProveedores.push(proveedorname);
                        }


                        
                        vm.getGastosNegocio();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        },


        getGastosNegocio() {

            if (this.datefrom === null || this.dateto === null) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            } else {

                let secondsDesde = moment(this.datefrom).unix();
                let secondsHasta = moment(this.dateto).unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {
                    this.loading = true;
                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            mode: this.mode,
                            datefrom: moment(this.datefrom)
                                .startOf("day")
                                .unix(),
                            dateto: moment(this.dateto)
                                .endOf("day")
                                .unix(),
                            procedencia: this.procedencia,
                            filtrarPorFecha: true,
                            idSupplier: this.idSupplier,
                            jwt: this.$store.getters.jwt,
                        },
                        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "suppliers/getExpenses", config)
                        .then(function (response) {


                            if (response.data.response) {
                                vm.respuesta = true;
                                vm.list = response.data.result;

                                //Si la lista está vacía, dejamos de cargar
                                if (vm.list.length == 0) {
                                    vm.loadingGeneral.close();
                                    vm.loading = false;
                                } else {
                                    //Buscamos las facturas para cada proveedor y las cargamos en un array
                                    for (let i = 0; i < vm.list.length; i++) {
                                        vm.getGastosProveedor(vm.list[i].supplierId)

                                    }
                                }





                            } else if (response.data.response == false && response.data.rangoMayor == true) {
                                swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                });
                                vm.respuesta = false;
                            } else {
                                swal({
                                    title: vm.$t('error'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                                vm.respuesta = false;

                            }
                            // vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        },

        //Del proveedor elegido por id, cargamos un array con todas sus facturas
        getGastosProveedor(idSupplier) {

            if (this.datefrom === null || this.dateto === null) {
                swal({
                    title: this.$t("ups"),
                    text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            } else {
                let secondsDesde = moment(this.datefrom).unix();
                let secondsHasta = moment(this.dateto).unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t("ups"),
                        text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                    });
                } else {


                    this.loading = true;
                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            mode: 1,
                            datefrom: moment(this.datefrom)
                                .startOf("day")
                                .unix(),
                            dateto: moment(this.dateto)
                                .endOf("day")
                                .unix(),
                            procedencia: this.procedencia,
                            filtrarPorFecha: true,
                            idSupplier: idSupplier,
                            jwt: this.$store.getters.jwt,
                        },
                        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                    };

                    let vm = this;
                    this.axios
                        .get(this.$store.getters.apiUrl + "gastos/getExpenses", config)
                        .then(function (response) {

                            
                            vm.loadingGeneral.close();
                            vm.loading = false;
                            if (response.data.response) {

                                vm.respuesta = true;

                                let currentFacturas = response.data.result;



                                vm.listEveryFactura.push(currentFacturas)
                                

                            } else {


                                swal({
                                    title: vm.$t("error"),
                                    text: response.data.message,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "error",
                                });
                                vm.respuesta = false;
                                // vm.$router.push({ name: 'informes'});
                            }
                        })
                        .catch(function (error) {
                            vm.loadingGeneral.close();
                            console.log(error);
                        });
                }
            }
        },


        arrayContainsCasa(listCasas, nameCasa) {
            let found = false;
            for (let i = 0; i < listCasas.length; i++) {
                if (listCasas[i]) {
                    if (listCasas[i].nameCasa === nameCasa) {
                        found = true;
                        break;
                    }
                }
            }
            return found;
        },


    },
}
</script>

<style scoped>
.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Proveedores/GastosPorProveedor.vue